document.addEventListener('DOMContentLoaded', function () {
  var ikmTabsContainers = document.querySelectorAll('[data-ikm-tabs]');

  if (!ikmTabsContainers.length) return;

  ikmTabsContainers.forEach(function (container) {
    var tabButtons = container.querySelectorAll('.ikm-tab-button');
    var tabPanels = container.querySelectorAll('.ikm-tab-panel');

    if (!tabButtons.length) return;

    tabButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var targetId = button.getAttribute('data-ikm-tab-trigger');
        if (!targetId) return;

        // Update active button state
        tabButtons.forEach(function (btn) {
          btn.classList.remove('ikm-tab-button--active');
        });
        button.classList.add('ikm-tab-button--active');

        // Update active panel
        tabPanels.forEach(function (panel) {
          if (panel.id === targetId) {
            panel.classList.add('ikm-tab-panel--active');
          } else {
            panel.classList.remove('ikm-tab-panel--active');
          }
        });
      });
    });
  });
});

